export const toFixed = (value: number, precision = 0) =>
  Number(value.toFixed(precision));

export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};
